<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, RouterLink } from 'vue-router';
import { menuStore } from './menu';

const route = useRoute();

const crumbs = computed(() => {
  const path = route.path;
  if (path === '/') return [{ title: 'Главная' }];

  const result: { title: string; to?: string }[] = [{ title: 'Главная', to: '/' }];
  for (const section of menuStore.sections) {
    const prefix = `/${section.id}`;
    if (path === prefix || path.startsWith(prefix + '/')) {
      result.push({ title: section.title, to: prefix });
      const match = section.items.find((i) => {
        const to = typeof i.to === 'string' ? i.to : '';
        return to && (path === to || path.startsWith(to + '/'));
      });
      if (match && typeof match.to === 'string') result.push({ title: match.title, to: match.to });
      else if (typeof route.meta?.title === 'string') result.push({ title: route.meta.title });
    }
  }
  if (
    result.length === 1 &&
    typeof route.meta?.title === 'string' &&
    route.meta.title !== 'Главная'
  ) {
    result.push({ title: route.meta.title });
  }
  return result;
});
</script>

<template>
  <nav class="botto-breadcrumbs">
    <template v-for="(c, i) in crumbs" :key="`${c.title}-${i}`">
      <RouterLink v-if="c.to && i < crumbs.length - 1" :to="c.to" class="botto-breadcrumbs__crumb">{{ c.title }}</RouterLink>
      <span v-else class="botto-breadcrumbs__crumb botto-breadcrumbs__crumb--current">{{ c.title }}</span>
      <span v-if="i < crumbs.length - 1" class="botto-breadcrumbs__sep">/</span>
    </template>
  </nav>
</template>

